<template>
  <div class="tag-management">
    <div class="toolbar">
      <el-button type="primary" @click="showAddDialog">添加标签</el-button>
    </div>

    <div class="filters">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索标签名称..."
        class="search-input"
        clearable
        @input="handleSearch"
        style="width: 300px;"
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
    </div>

    <el-table :data="displayItems" border v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="created_at" label="创建时间" width="180">
        <template #default="{ row }">
          {{ formatDate(row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button size="small" @click="editItem(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteItem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="total > 0"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, { value: -1, label: '全部' }]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      class="pagination"
    />

    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="名称" required>
          <el-input v-model="form.name" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveItem">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api'
import { Search } from '@element-plus/icons-vue'

export default {
  name: 'TagManagement',
  components: {
    Search
  },
  data() {
    return {
      items: [],
      searchKeyword: '',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      dialogVisible: false,
      dialogTitle: '添加标签',
      form: {
        name: ''
      },
      currentId: null
    }
  },
  computed: {
    displayItems() {
      return this.items
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize === -1 ? 'all' : this.pageSize
        }
        
        // 添加搜索
        if (this.searchKeyword) {
          params.search = this.searchKeyword
        }
        
        const response = await api.get('/admin/market/tags/', { params })
        
        if (Array.isArray(response.data)) {
          this.items = response.data
          this.total = response.data.length
        } else {
          this.items = response.data.results || []
          this.total = response.data.count || 0
        }
      } catch (error) {
        this.$message.error('加载失败')
        this.items = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    showAddDialog() {
      this.dialogTitle = '添加标签'
      this.currentId = null
      this.form = {
        name: ''
      }
      this.dialogVisible = true
    },
    editItem(item) {
      this.dialogTitle = '编辑标签'
      this.currentId = item.id
      this.form = {
        name: item.name
      }
      this.dialogVisible = true
    },
    async saveItem() {
      try {
        if (!this.form.name) {
          this.$message.warning('请输入名称')
          return
        }
        if (this.currentId) {
          await api.put(`/admin/market/tags/${this.currentId}/`, this.form)
          this.$message.success('更新成功')
        } else {
          await api.post('/admin/market/tags/', this.form)
          this.$message.success('添加成功')
        }
        this.dialogVisible = false
        this.loadItems()
      } catch (error) {
        this.$message.error('保存失败')
        console.error(error)
      }
    },
    async deleteItem(item) {
      try {
        await this.$confirm(`确定要删除标签"${item.name}"吗？`, '提示', {
          type: 'warning'
        })
        await api.delete(`/admin/market/tags/${item.id}/`)
        this.$message.success('删除成功')
        this.loadItems()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
          console.error(error)
        }
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.loadItems()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadItems()
    },
    handlePageChange(page) {
      this.currentPage = page
      if (this.pageSize !== -1) {
        this.loadItems()
      }
    }
  }
}
</script>

<style scoped>
.tag-management {
  color: #e0e0e0;
}

.toolbar {
  margin-bottom: 20px;
}

.filters {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>

